export type vPort = 'xs' | 'sm' | 'md' | 'lg' | 'xlg';



export function VPortListener(value: vPort) {
    let isMobile : boolean;
    const getter = function() {
        return isMobile;
    };
    const setter = function(newVal: boolean) {
        isMobile = newVal;     
    };

    return function (target: any, propertyKey: string) {
        // register vPort
        target.vPort = value;

        // redefine property to access it
        Object.defineProperty(target, propertyKey, {
            get: getter,
            set: setter
        });

        /**
         * create custom events for earch property which can be overridden
         * by the class
         */
        const [onEvent,offEvent] =[`${propertyKey}On`, `${propertyKey}Off`];
        // update it via setter
        if(!target[onEvent]) {
            target[onEvent] = () => {
                setter(true);
            };
        }

        if(!target[offEvent]) {
            target[offEvent] = () => {
                setter(false);
            };
        }
        
        // override parent registered event *remove it*
        const parent = Object.getPrototypeOf(target);
        if(parent.vPort) {
            document.removeEventListener(`screen-${parent.vPort}-on`, parent[onEvent].bind(parent));
            document.removeEventListener(`screen-${parent.vPort}-off`, parent[offEvent].bind(parent));
        }
        // register vPort listeners
        document.addEventListener(`screen-${value}-on`, target[onEvent].bind(target));
        document.addEventListener(`screen-${value}-off`, target[offEvent].bind(target));
    }
}
